// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"d35189dd","171":"2cb40fa8","488":"6a13ddaf","994":"6e9df905"}[chunkId] + ".chunk.js";
};